/**
 * Mock Countries data.
 * @type {import('../types').Country[]}
 */
const countries = [
  { id: 1, country: "United Arab Emirates", countryCode: "AE" },
  { id: 2, country: "Saudi Arabia", countryCode: "SA" },
  { id: 3, country: "Qatar", countryCode: "QA" },
  { id: 4, country: "Bahrain", countryCode: "BH" },
  { id: 5, country: "Kuwait", countryCode: "KW" },
  { id: 6, country: "Oman", countryCode: "OM" },
  { id: 7, country: "Pakistan", countryCode: "PK" },
  { id: 8, country: "India", countryCode: "IN" },
  { id: 9, country: "Turkey", countryCode: "TR" },
  { id: 10, country: "United Kingdom", countryCode: "GB" },
  { id: 11, country: "United States", countryCode: "US" },
  { id: 12, country: "Bangladesh", countryCode: "BD" },
  { id: 13, country: "Sri Lanka", countryCode: "LK" },
  { id: 14, country: "Egypt", countryCode: "EG" },
  { id: 15, country: "Jordan", countryCode: "JO" },
  { id: 16, country: "Malaysia", countryCode: "MY" },
  { id: 17, country: "Thailand", countryCode: "TH" },
  { id: 18, country: "Indonesia", countryCode: "ID" },
  { id: 19, country: "Germany", countryCode: "DE" },
  { id: 20, country: "France", countryCode: "FR" },
];

export default countries;
